import { getImageUrl } from "src/Common/common";
import { ActionMenu, ActionMenuIcon, ActionMenuItem } from "src/Components/Common/ActionMenu";
import { ReopenMenuIcon } from "src/Pages/WO/Components/common/DocumentRowIcons";

const FilledOptions = ({
  onReopen,
  onDuplicate,
  onUnassign,
  onClose,
  canReopen = true,
  canDuplicate = true,
  canUnassign = true,
}) => {
  return (
    <ActionMenu onClose={onClose}>
      {canReopen && (
        <ActionMenuItem onClick={onReopen} title="Reopen">
          <ReopenMenuIcon />
        </ActionMenuItem>
      )}
      {canDuplicate && (
        <ActionMenuIcon
          onClick={onDuplicate}
          title="Duplicate"
          src={getImageUrl("/images/common/white_duplicate.png")}
        />
      )}
      {canUnassign && (
        <ActionMenuIcon
          onClick={onUnassign}
          title="Unassign"
          src={getImageUrl("/images/common/white_repeat.png")}
        />
      )}
    </ActionMenu>
  );
};

export default FilledOptions;
